import React, { useEffect, useState } from 'react'
import UserName from '../common/user/UserName';
import { useNavigate } from 'react-router-dom';
import { locationsData } from '../locations/Locations';
import { AnyIfEmpty, useSelector } from 'react-redux';
import { AppDispatch, IRootState } from '../../redux/rootReducer';
import Loader from '../common/loader/Loader';
import { useDispatch } from 'react-redux';
import { getFilteredLocation, getSearchLocation } from '../../redux/location/actions/location.action';
import AmenitiesCard from './amenitiesCard/amenitiesCard';
import { useDebounce } from '../../utils/useDebounce';
import SearchIcon from '../../images/icon-search.svg';
import styles from './amenities.module.css';
import { hasPermission } from '../auth/login/Login';

const AmenitiesPage = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const allLocationsList = useSelector((state: IRootState) => state.locationReducer.data.locations);
    const invitedLocations = useSelector((state: IRootState) => state.locationReducer.data?.locationinvitedlist);
    const locationLoading = useSelector((state: IRootState) => state.locationReducer.loading);
    const error = useSelector((state: IRootState) => state.locationReducer.errorMsg);
    const [locations, setLocations] = useState<locationsData[]>([]);

    const [searchText, setSearchText] = useState('');
    const searchWithDebounce = useDebounce(searchText, 1000);
    const permissionLoading = useSelector((state: IRootState) => state?.permissionsReducer?.loading);
    const canViewAmenities = hasPermission("Amenity", "Amenities", "read");

    // useEffect(() => {
    //     dispatch(getFilteredLocation('', ''));
    // }, ['']);

    useEffect(() => {
        dispatch(
            getSearchLocation(
                searchWithDebounce,
                '',
            ),
        );
    }, [searchWithDebounce]);

    useEffect(() => {
        if (!invitedLocations?.length && !allLocationsList?.length) {
            setLocations([]);
        } else {
            if (invitedLocations?.length || allLocationsList?.length) {
                const data = invitedLocations?.map((list: locationsData) => {
                    return {
                        ...list,
                        isRestricted: true,
                    };
                });
                setLocations([...data, ...allLocationsList]);
            }
        }
    }, [allLocationsList?.length, invitedLocations?.length]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const trimmedValue = value.replace(/^\s+/, '');

        setSearchText(trimmedValue);
    };

    return (
        <div className={`${styles.pageConatiner} ${styles.amenitiesPageContainer}`}>

            {/* loader */}
            {locationLoading && <Loader />}


            {/* header */}
            <div className={styles.amenitiesHeader}>
                <div className={styles.userGreet}>
                    <p>Welcome <UserName /></p>
                    <h2>Amenities</h2>
                </div>


                {canViewAmenities && <div className={styles.search}>
                    <input
                        onChange={(e) => handleChange(e)}
                        type="text"
                        placeholder="Start to type.."
                        maxLength={50}
                        value={searchText}
                    />
                    <img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
                </div>}
            </div>

            {canViewAmenities && <div className={styles.listingWrapper}>
                {/* listing */}
                {locations?.length > 0 ? (
                    <div className={styles.locationWrapper}>
                        {locations.map((location: AnyIfEmpty<object>, index: number) => (
                            <AmenitiesCard location={location} key={index} handleLocationCard={(locationId: string | undefined) => {
                                if (locationId) {
                                    navigate(`/amenities/${locationId}`)
                                }
                            }
                            } />
                        ))}
                    </div>
                ) : (!locationLoading && !locations) && (
                    <div className={styles.noRecordsWrapper}>
                        <div className={styles.noRecordsContent}>
                            <p>No Records Found</p>
                        </div>
                    </div>
                )}
            </div>}
        </div>
    )
}

export default AmenitiesPage
